import { useAnalyticContext } from '@application/analytic/analytic_link/mod';
import { withTranslation } from '@application/i18n/with_translation';
import { IllustrativeView } from '@component/illustrative_view.component';
import { TopBar } from '@component/top_bar.component';
import { useEffect } from 'react';
import { useCreateNewMessage } from '../../hooks/use-create-new-message';

export function ScreenNhsLoginRequired() {
	const { goToReceptionHome } = useCreateNewMessage();
	const analytics = useAnalyticContext();

	useEffect(() => {
		analytics.service.trackPageView({ customTitle: 'Create new message: NHS login required' });
	}, [analytics]);

	return (
		<>
			<TopBar.Content onAbort={null} />
			<IllustrativeView
				title={withTranslation('View.RedRobin.NhsLoginRequired.Title')}
				description={withTranslation('View.RedRobin.NhsLoginRequired.Body')}
				illustration='error'
				callToAction={withTranslation('View.RedRobin.NhsLoginRequired.Button')}
				callToActionCallback={goToReceptionHome}
			/>
		</>
	);
}
